import React from 'react';
import GuestImageGeneration from '@/components/GuestImageGeneration';

const TryGenerator = () => {
  return <GuestImageGeneration />;
};

export default TryGenerator;